import { useEffect, useState } from 'react';
import { useGetTwoFactorConf } from 'server';
import { getLocationParam, isJavascriptLink } from 'js/utils/url.util';
import { htcmdService } from 'js/services/htcmd.service';
import { useRemoveQueryParams } from 'js/hooks/navigate';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { storageService } from 'js/services/storage.service';
import { getFitToPlaySubmissionRequired } from 'js/hooks/auth/pas';

export const useInitLogin = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadingError, setLoadingError] = useState('');
    const [isRememberMeSupported, setIsRememberMeSupported] = useState(false);
    const [isRememberDeviceSupported, setIsRememberDeviceSupported] = useState(false);
    const [isFitToPlaySubmissionRequired, setIsFitToPlaySubmissionRequired] = useState(false);
    const getErrorMessage = useGetErrorMessage();
    const getTwoFactorConf = useGetTwoFactorConf();
    const removeQueryParams = useRemoveQueryParams();

    useEffect(() => {
        const afterLoginUrl = getLocationParam('afterLoginUrl');

        if (afterLoginUrl) {
            if (!isJavascriptLink(afterLoginUrl)) {
                storageService.session.setItem('afterLoginUrl', afterLoginUrl);
            }

            removeQueryParams(['afterLoginUrl']);
        }

        setIsFitToPlaySubmissionRequired(getFitToPlaySubmissionRequired());

        (async () => {
            try {
                const { twoFactorConf } = await getTwoFactorConf();

                setIsRememberMeSupported(twoFactorConf?.rememberMeWithoutTwoFactor === 'ON'
                    && !htcmdService.isEnabled && !htcmdService.isWrapperEnabled
                );
                setIsRememberDeviceSupported(Boolean(twoFactorConf.loginDeviceSupported));
            } catch (error: any) {
                setLoadingError(getErrorMessage(error));
            } finally {
                setIsLoaded(true);
            }
        })();
    }, [
        getErrorMessage,
        getTwoFactorConf,
        removeQueryParams
    ]);

    return {
        isLoaded,
        loadingError,
        isRememberMeSupported,
        isRememberDeviceSupported,
        isFitToPlaySubmissionRequired
    };
};
